import React from "react";

type KakaoIconProps = {
  size?: number;
  className?: string;
};

/** Kakao Talk bubble — matches official login button artwork. */
const KakaoIcon: React.FC<KakaoIconProps> = ({ size = 20, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 1.5C4.85775 1.5 1.5 4.542 1.5 8.25c0 2.343.975 4.425 2.5035 5.862L3 16.5l2.817-1.485C6.711 15.414 7.827 15.75 9 15.75c4.14225 0 7.5-3.042 7.5-6.75S13.1423 1.5 9 1.5z"
      fill="currentColor"
    />
  </svg>
);

export default KakaoIcon;
